// Barra de progreso 1/6, fija arriba.
//
// Uso:
//   renderProgressBar(host, { current: 2, total: 6 });

export function renderProgressBar(host, { current, total }) {
  if (!host) return;
  const pct = Math.max(0, Math.min(100, (current / total) * 100));
  host.innerHTML = `
    <div class="progress" role="progressbar"
         aria-valuemin="1" aria-valuemax="${total}" aria-valuenow="${current}"
         aria-label="Paso ${current} de ${total}">
      <div class="progress__track">
        <div class="progress__fill" style="width: ${pct}%"></div>
      </div>
      <div class="progress__label">Paso ${current} de ${total}</div>
    </div>
  `;
}
